<template>
  <div>
    <div class="margin-bottom-10" v-if="!isDesMobile&&mode!='icon'">
      <el-button type="primary" v-if="online==1" @click="triggerSendVideoCallOther"
                 :style="lang=='en'?'min-width: 122px;':''"
      >{{$t('lang.视频通话')}}
      </el-button>
      <el-button
        :style="lang=='en'?'min-width: 122px;':''"
        :disabled="true" v-if="online==0">{{$t('lang.视频通话')}}
      </el-button>
    </div>
    <div class="margin-bottom-10" v-if="!isDesMobile&&mode=='icon'">
      <img
        src="@match/assets/images/icon-video.png"
        v-if="online==1"
        class="m-btn-icon cursor"
        @click="triggerSendVideoCallOther"
      />
      <img
        src="@match/assets/images/icon-video.png"
        v-if="online==0  || !online"
        class="m-btn-icon opacity"
      />
    </div>
  </div>
</template>
<script>
  import {createProp} from "@common/utils";
  import {
    createConversation,
    createMessagePayload,
    createVideoWxPayload,
    sendMessageToGroup,
    sendVideoCall2wx
  } from "@common/utils/imUtils.js";
  import messageStoreMixin from "@match/store/message/messageStoreMixin";
  import {push} from "@common/utils/routerUtil";
  import myalert from "@common/utils/myalert";
  import {uuidNumber} from "@common/utils";
  import {getProjectId} from "@common/utils";
  import {
    appointment_type_message,
    appointment_type_message_china,
    messageType_videoCallInvite, personage_system_group
  } from "@common/constact";
  import {mapGetters} from "vuex";
  import {createA} from "@common/utils";
  import {params2url} from "@common/utils";
  import ajax from "@common/utils/ajax";
  import {getNickName} from "@common/utils";
  import {getLoginUser} from "@common/utils";
  import loginCommon from "@match/components/login/loginDialog";

  export default {
    mixins: [messageStoreMixin],
    data() {
      return {
        loginVisible: false,
      }
    },
    // inject: ['reload'],
    computed: {
      ...mapGetters("mobile", [
        "isDesMobile"
      ]),
    },
    props: {
      userId: createProp([String, Number]),
      online: createProp([String, Number]),
      mode:createProp([String, Number]), //mode=icon 说明使用图片显示
    },
    mounted() {
      // this.$router.go(0)
    },
    components: {
      loginCommon
    },
    methods: {
      async triggerSendVideoCallOther() {
        /*
        加好友
        createa对话
        * 对话的消息array
        发送 视频邀请消息
        * 跳转界面*/
        var currentUser = getLoginUser()
        if (currentUser.id == this.userId) {
          myalert.fail(this.$t('lang.不能和自己通话'))
          return false
        }
        if (currentUser.id == null || currentUser.id == undefined || currentUser.id == '') {
          this.loginVisible = !this.loginVisible
          return false
        }
        console.log("=to userId=======>", this.userId)
        var result = await createConversation({
          from: currentUser.id,
          to: this.userId
        }).catch(e => {
          console.log("======e==>", e)
          myalert.fail('对方还未登录系统，目前不能联系')
          return false
        })
        if (!result) return false
        var roomId = uuidNumber()
        var url = `/videoCall/detail?${params2url({
          roomId: roomId,
          projectId: getProjectId(),
          beginTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        })}`
        ajax.get(`/api3/backend/v1/statistics/addInstantMessageNum/${getProjectId()}?type=video`)
        var text = getNickName()
        /*   sendMessageToGroup(createMessagePayload(
               url,
               `${text}邀请你视频聊天`,
               appointment_type_message.videoCall),
               personage_system_group + this.userId)*/

        //给小程序发消息
        sendVideoCall2wx(this.userId, createVideoWxPayload(text, getLoginUser().id, roomId))
        if (this.isDesMobile) {
          url = url + '&date=' + new Date()
          push(url)
          return false
        } else {
          window.open(url)
          return false
        }
      }
    }

  }
</script>
<style scoped>
  .m-btn-icon {
    height: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/wenxing/components/videoCallButton.vue